"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _internalRouter = _interopRequireDefault(require("../lib/internalRouter"));

/**
 * Returns a simple custom router. This router can be
 * used for imperative navigation and for checking for
 * path matches.
 */
var useRouter = function useRouter() {
  return _internalRouter["default"];
};

var _default = useRouter;
exports["default"] = _default;